import * as React from "react";
const SvgAdministrationFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 5c-4 0-8-3-8-3S8 5 4 5v12s5.976 5 8 5c2.067 0 8-5 8-5zM9.623 12.773l-.562 3.272 2.94-1.545 2.938 1.545-.561-3.273 2.378-2.317-3.286-.478L12 7l-1.47 2.977-3.285.478z", clipRule: "evenodd" }));
export default SvgAdministrationFill;
